import * as v from './vector';
import * as shapes from './shapes';

export const K3D = {
  Vector2: v.Vector2,
  Vector3: v.Vector3,
  Vector4: v.Vector4,
  Transform: v.Transform,
  FullTransform: v.FullTransform,

  Box2: shapes.Box2,
  Box3: shapes.Box3,
  Line2: shapes.Line2,
  Line3: shapes.Line3,

  integerCoordinates2D: shapes.integerCoordinates2D,
  intersectionBox2D: shapes.intersectionBox2D,
}
export namespace K3D {
  export type Vector2 = v.Vector2;
  export type Vector3 = v.Vector3;
  export type Vector4 = v.Vector4;

  export type Transform = v.Transform;
  export type FullTransform = v.FullTransform

  export type Box2 = shapes.Box2;
  export type Box3 = shapes.Box3;
  export type Line2 = shapes.Line2;
  export type Line3 = shapes.Line3;
};

